// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-form-overlay {
    position: fixed;
    z-index: 999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
}

.file-form {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    width: 400px;
    max-width: 100%;
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.file-image {
    width: 200px;
    height: auto;
    margin-bottom: 10px;
    border-radius: 5px;
}

.file-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
}

button {
    margin-top: 10px;
}

.upload-btn {
    background-color: #0098e5;
    border: none;
    color: white;
    padding: 8px 16px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 4px;
}
.upload-btn:hover {
    background-color: #2194cc;
}

.file-action {
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
}

.file-action-button {
    background-color: var(--primary-color);
    color: #fff;
    border: none;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;
}

.file-action-button:hover {
    background-color: #2194cc;
}

/* Dropdown Content (Hidden by Default) */
.file-action-menu-content {
    display: none;
    position: absolute;
    background-color: #f1f1f1;
    min-width: 160px;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
    z-index: 1;
}

/* Links inside the dropdown */
.file-action-menu-content a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
}

/* Show the dropdown menu on hover */
.file-action-button:hover + .file-action-menu-content {
    display: block;
}

.file-action-menu-content button {
    color: black;
    padding: 12px 16px;
    display: block;
}

.file-action-container:hover .file-action-menu-content {
    display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/FileManager.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,cAAc;IACd,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,YAAY;IACZ,eAAe;IACf,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,yCAAyC;AACzC;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,2CAA2C;IAC3C,UAAU;AACd;;AAEA,8BAA8B;AAC9B;IACI,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,oCAAoC;AACpC;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".file-form-overlay {\n    position: fixed;\n    z-index: 999;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    background-color: rgba(0, 0, 0, 0.4);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.file-form {\n    background-color: #fff;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    width: 400px;\n    max-width: 100%;\n    padding: 24px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.file-image {\n    width: 200px;\n    height: auto;\n    margin-bottom: 10px;\n    border-radius: 5px;\n}\n\n.file-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\nbutton {\n    margin-top: 10px;\n}\n\n.upload-btn {\n    background-color: #0098e5;\n    border: none;\n    color: white;\n    padding: 8px 16px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    margin: 4px 2px;\n    cursor: pointer;\n    border-radius: 4px;\n}\n.upload-btn:hover {\n    background-color: #2194cc;\n}\n\n.file-action {\n    position: absolute;\n    right: 0;\n    top: 0;\n    display: flex;\n    align-items: center;\n}\n\n.file-action-button {\n    background-color: var(--primary-color);\n    color: #fff;\n    border: none;\n    padding: 10px;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.2s ease-in-out;\n}\n\n.file-action-button:hover {\n    background-color: #2194cc;\n}\n\n/* Dropdown Content (Hidden by Default) */\n.file-action-menu-content {\n    display: none;\n    position: absolute;\n    background-color: #f1f1f1;\n    min-width: 160px;\n    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n    z-index: 1;\n}\n\n/* Links inside the dropdown */\n.file-action-menu-content a {\n    color: black;\n    padding: 12px 16px;\n    text-decoration: none;\n    display: block;\n}\n\n/* Show the dropdown menu on hover */\n.file-action-button:hover + .file-action-menu-content {\n    display: block;\n}\n\n.file-action-menu-content button {\n    color: black;\n    padding: 12px 16px;\n    display: block;\n}\n\n.file-action-container:hover .file-action-menu-content {\n    display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
